//External Libraries
import { useTranslation } from 'react-i18next';

//Utils
import { DEFAULT_CATEGORY_COLOR, getTranslatedCategoryName } from '../utils';

//Types
import type { AnnouncementCategoryInfo } from '../types';

function hexToRgba(hex: string, alpha: number): string {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

interface Props {
  category: AnnouncementCategoryInfo;
}

function AnnouncementTag({ category }: Props) {
  const { i18n } = useTranslation();
  const displayName = getTranslatedCategoryName(category, i18n.language);
  const borderColor = category.color || DEFAULT_CATEGORY_COLOR;
  const backgroundColor = hexToRgba(borderColor, 0.18);

  return (
    <span
      className="inline-block text-xs font-medium px-2.5 py-0.5 rounded-xs border border-solid leading-relaxed tracking-wide"
      style={{ backgroundColor, borderColor, color: borderColor }}
    >
      {displayName}
    </span>
  );
}

export default AnnouncementTag;
